<template>
    <div>
        <router-link to="/">Home</router-link>
		<router-link to="/admin">Admin</router-link>
		<router-link to="/client">Client</router-link>
		<router-link to="/invitee">Invitee</router-link>
        <router-link to="/login">Login</router-link>
        <router-link to="/register">Register</router-link>

        <b-container class="mt-5">
            <b-row>
                <b-col class="text-center">
                    <img class="w-50" src="../assets/logo.jpg" alt="">

                    <h1 class="mt-3">
                        Clubs Away Event Management
                    </h1>

                    <p class="h4">
                        Please login or register to view your events
                    </p>
                    
                    <div class="mt-4">
                        <b-button to="/login" class="btn-info w-25">
                            Login
                        </b-button>

                        <b-button to="/register" class="btn-info ml-3 w-25">
                            Register
                        </b-button>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style scoped lang="scss">
    h1 {
        /*color: #c4a119;*/
      color: $color-dark-blue;
    }

    button a {
        color: white;
    }
</style>